<template>
	<div class="home container">
		<el-row :gutter="20" >

		  <el-col :span="8">
				<el-card class="box-card"  v-loading="loading">
				  <div slot="header" class="clearfix">
				    基本情况
<!-- 				    <el-button style="float: right; padding: 3px 0" type="text">审核</el-button> -->
				  </div>
				  <div  class="text item">
				  	学员数量 <span>&nbsp;位</span> <span class="blue">{{xys}}/{{max}}</span>
				  	<el-progress :percentage="maxpc" status="success" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">车辆数量 <span>&nbsp;辆</span> <span class="blue">{{cls}}</span></div>
				  <div  class="text item">文章数量 <span>&nbsp;篇</span> <span class="blue">{{wzs}}</span></div>
				</el-card>
		  </el-col>


		  <el-col :span="8">
				<el-card class="box-card"  v-loading="loading">
				  <div slot="header" class="clearfix">
				    本月审核情况
<!-- 				    <el-button style="float: right; padding: 3px 0" type="text">审核</el-button> -->
				  </div>
				  <div  class="text item">
				  	已通过 <span>&nbsp;位</span> <span class="blue">{{shsd}}/{{xys}}</span>
				  	<el-progress :percentage="shsdpc" status="success" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">
				  	待审核 <span>&nbsp;位</span> <span class="blue">{{shs-shsn-shsd}}</span>
				  </div>
				  <div  class="text item">
				  	未通过 <span>&nbsp;位</span> <span class="blue">{{shsn}}</span>
				  </div>
				</el-card>
		  </el-col>

		  <el-col :span="8">
				<el-card class="box-card"  v-loading="loading">
				  <div slot="header" class="clearfix">
				    本月学习情况
<!-- 				    <el-button style="float: right; padding: 3px 0" type="text">审核</el-button> -->
				  </div>
				  <div  class="text item">
				  	完成学习 <span>&nbsp;位</span> <span class="blue">{{xysd}}/{{xys}}</span>
				  	<el-progress :percentage="xysdpc" status="success" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">
				  	学习中 <span>&nbsp;位</span> <span class="blue">{{xys-xysn-xysd}}/{{xys}}</span>
				  	<el-progress :percentage="xyszpc" color="#8e71c7" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">
				  	未开始 <span>&nbsp;位</span> <span class="blue">{{xysn}}/{{xys}}</span>
				  	<el-progress :percentage="xysnpc" status="exception" :show-text='false'></el-progress>
				  </div>
				</el-card>
		  </el-col>

		  <el-col :span="8">
				<el-card class="box-card"  v-loading="loading">
				  <div slot="header" class="clearfix">
				    车辆情况
<!-- 				    <el-button style="float: right; padding: 3px 0" type="text">审核</el-button> -->
				  </div>
				  <div  class="text item">
				  	完好车辆 <span>&nbsp;辆</span> <span class="blue">{{clsd}}/{{cls}}</span>
				  	<el-progress :percentage="clsdpc" status="success" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">
				  	维修车辆 <span>&nbsp;辆</span> <span class="blue">{{cls-clsn-clsd}}/{{cls}}</span>
				  	<el-progress :percentage="clszpc" color="#8e71c7" :show-text='false'></el-progress>
				  </div>
				  <div  class="text item">
				  	停运车辆 <span>&nbsp;辆</span> <span class="blue">{{clsn}}/{{cls}}</span>
				  	<el-progress :percentage="clsnpc" status="exception" :show-text='false'></el-progress>
				  </div>
				</el-card>
		  </el-col>

		</el-row>
	</div>
</template>

<script>
  export default {
    data() {
      return {
      	loading:true,
      };
    },
    created(){
		setTimeout(() => {
		  this.loading = false
		},2000);
    },
	computed:{
		max(){
			return this.$store.getters.max;
		},
		maxpc(){
			return parseInt(100*this.xys/this.max)
		},
		xys(){
			return this.$store.state.xueyuan.length;
		},
		shs(){
			return this.$store.getters.getShs;
		},
		cls(){
			return this.$store.state.cheliang.length;
		},
		wzs(){
			return this.$store.state.sext.length;
		},

		xysd(){
			return this.$store.getters.getXysd;
		},
		xysdpc(){
			return parseInt(100*this.xysd/this.xys) || 0;
		},
		xysn(){
			return this.$store.getters.getXysn;
		},
		xysnpc(){
			return parseInt(100*this.xysn/this.xys) || 0;
		},
		xyszpc(){
			return parseInt(100*(this.xys-this.xysn-this.xysd)/this.xys) || 0;
		},

		shsd(){
			return this.$store.getters.getShsd;
		},
		shsdpc(){
			return parseInt(100*this.shsd/this.shs) || 0;
		},
		shsn(){
			return this.$store.getters.getShsn;
		},


		clsd(){
			return this.$store.getters.getClsd;
		},
		clsdpc(){
			return parseInt(100*this.clsd/this.cls) || 0;
		},
		clsn(){
			return this.$store.getters.getClsn;
		},
		clsnpc(){
			return parseInt(100*this.clsn/this.cls) || 0;
		},
		clszpc(){
			return parseInt(100*(this.cls-this.clsn-this.clsd)/this.cls) || 0;
		},


	},
  }
</script>

<style>
  .home .text {
    font-size: 14px;
  }
  .home .item {
    margin-bottom: 18px;
  }
  .home span{
  	float: right
  }
  .home .blue{
  	color: blue
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue